import React, { Component } from "react";
import styles from "./logisticReports.module.scss";
import { MapContainer, TileLayer, Marker, Circle, MapConsumer, Popup, GeoJSON } from "react-leaflet";
import { withMapControl } from "../../../shared/containers/containerMapControl";
import L from "leaflet";
import { ControlPointIcon } from "../ControlPoints/ControlPointIcon";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import getDates from "../../../shared/services/date.service";
import AntPath from "../../AntPath/AntPath";
import TopRightMapControl from "../../LayerMapCotrol/TopRightMapControl";
import BaseLayerMapControl from "../../LayerMapCotrol/BaseLayerMapControl";
import { withAppState } from "../../../shared/containers/containerAppState";
import TooltipWrapper from "../../../shared/items/contols/tooltipWrapper";
import LayersIcon from "@mui/icons-material/Layers";
import MapMarkerTaskTrip from "../Monitorings/UnitsTaskTripMap/MapMarkerTaskTrip";

class LogisticReportsTaskTripMap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxLocation: null,
      nimLocation: null,
      isOverlayerControlOpen: false,
      isControlPointsView: true,
      isRouteGeometryView: true,
      viewUnits: [],
    };
  }

  componentDidMount() {
    const { controlPoints, taskTrip } = this.props;

    const longitudes = controlPoints.map((x) => {
      return x.longitude;
    });

    const latitudes = controlPoints.map((x) => {
      return x.latitude;
    });

    const maxLocation = {
      lon: Math.max(...longitudes),
      lng: Math.max(...latitudes),
    };

    const minLocation = {
      lon: Math.min(...longitudes),
      lng: Math.min(...latitudes),
    };

    this.setState({ maxLocation, minLocation });

    let isViewUnit = true;

    const viewUnits = taskTrip.units.map((unit) => {
      const viewUnit = {
        isView: isViewUnit,
        id: unit.id,
        title: unit.title,
        registerNumber: unit.registerNumber,
      };

      isViewUnit = false;
      return viewUnit;
    });

    this.setState({ viewUnits });
  }

  getIcon(color, number) {
    return L.divIcon({
      html: `<div style="display: flex; color: ${color}">${ControlPointIcon.getIcon(color)} <div><b> ${number}</b></div></div>`,
      className: "svg-icon",
      iconSize: [26, 26],
      iconAnchor: [6, 25],
    });
  }

  onClose() {
    const { onSetViewMapState } = this.props;

    onSetViewMapState(false);
  }

  onChangeUnitView(id, isView) {
    const { viewUnits } = this.state;

    viewUnits.forEach((unit) => {
      if (unit.id === id) {
        unit.isView = isView;
      }
    });

    this.setState({ viewUnits });
  }

  render() {
    const { mapBaseLayer, height = 300, isTaskTripCompleted, taskTrip, isSideBarOpen, controlPointView } = this.props;
    const { maxLocation, minLocation, isOverlayerControlOpen, isControlPointsView, isRouteGeometryView, viewUnits } = this.state;

    let orderCountControlPoint = 1;

    const center = controlPointView !== null ? [controlPointView.latitude, controlPointView.longitude] : [53, 27];
    const zoom = controlPointView !== null ? mapBaseLayer.maxZoom : 15;

    return (
      <div className={styles.taskTripReportMapContainer} key={taskTrip.id}>
        <div style={{ position: "absolute", zIndex: "600", right: "15px", top: "15px" }} onClick={this.onClose.bind(this)}>
          <HighlightOffIcon style={{ color: "red", cursor: "pointer" }} />
        </div>

        <div className={styles.taskTripReportMapContainer}>
          <MapContainer
            key={`${taskTrip.id} ${mapBaseLayer.name}  ${isSideBarOpen} ${center[0]} ${center[1]}`}
            center={center}
            zoom={zoom}
            maxZoom={mapBaseLayer.maxZoom}
            minZoom={3}
            crs={mapBaseLayer.crs}
            zoomControl={true}
            attributionControl={false}
            doubleClickZoom={true}
            scrollWheelZoom={true}
            dragging={true}
            animate={true}
            easeLinearity={0.35}
            className={styles.taskTripReportMap}
            style={{ height: `${height}px` }}
          >
            <MapConsumer>
              {(map) => {
                if (minLocation.lng !== Infinity && controlPointView === null) {
                  map.fitBounds(
                    new L.latLngBounds([
                      new L.latLng(minLocation.lng, minLocation.lon),
                      new L.latLng(maxLocation.lng, maxLocation.lon),
                    ]).pad(0.2)
                  );
                }

                return null;
              }}
            </MapConsumer>

            {mapBaseLayer.url.map((_url, index) => {
              return <TileLayer key={mapBaseLayer.name + index} url={_url} updateWhenIdle={true} maxZoom={mapBaseLayer.maxZoom} />;
            })}

            {taskTrip.units.map((unit) => {
              if (!isControlPointsView) return null;

              const isView = viewUnits.some((x) => {
                return x.id === unit.id && x.isView;
              });

              if (!isView || unit.mapPositions.routes.length === 0) return null;

              return (
                <div key={unit.id}>
                  {unit.routes.map((route) => {
                    return (
                      <div key={route.id}>
                        {route.controlPoints.map((controlPoint) => {
                          let colorMarker = controlPoint.status === 1 ? "green" : "#757575";
                          if ((isTaskTripCompleted && controlPoint.status === 0) || controlPoint.status > 1) colorMarker = "red";

                          return (
                            <div key={controlPoint.id}>
                              <Marker
                                draggable={false}
                                icon={this.getIcon(colorMarker, orderCountControlPoint++)}
                                position={[controlPoint.latitude, controlPoint.longitude]}
                              >
                                <Circle
                                  color={colorMarker}
                                  key={`${controlPoint.radius} ${controlPoint.latitude} ${controlPoint.longitude}`}
                                  center={[controlPoint.latitude, controlPoint.longitude]}
                                  radius={Number(controlPoint.radius)}
                                >
                                  <Popup className="mapPopup">
                                    <div className="mapPopupContent">
                                      <b>Транспортное средство: </b> <span> {controlPoint.unit.title}</span>
                                    </div>

                                    <div className="mapPopupContent">
                                      <b>Регистрационный номер: </b> <span> {controlPoint.unit.registerNumber}</span>
                                    </div>

                                    <div className="mapPopupContent">
                                      <span>
                                        Посещено:{" "}
                                        {!controlPoint.timeEvent.includes("0001-01-01")
                                          ? getDates.getDateFormat9(controlPoint.timeEvent)
                                          : ""}
                                      </span>
                                    </div>

                                    <div className="mapPopupContent">
                                      <span>Наименование контрольной точки: {controlPoint.title}</span>
                                    </div>
                                    <div className="mapPopupContent">
                                      <span>Адрес: {controlPoint.address}</span>
                                    </div>
                                    <div className="mapPopupContent">
                                      <span>Адрес по локации: {controlPoint.geocoderAddress}</span>
                                    </div>

                                    {controlPoint.description !== null && controlPoint.description !== undefined ? (
                                      <div className="mapPopupContent">
                                        <span>Описание: {controlPoint.description}</span>
                                      </div>
                                    ) : null}

                                    <div className="mapPopupContent">
                                      <span>Радиус: {controlPoint.radius} м.</span>
                                    </div>
                                    <div className="mapPopupContent">
                                      <span>Максимальная скорость: {controlPoint.maxSpeed} км./ч.</span>
                                    </div>
                                  </Popup>
                                </Circle>
                              </Marker>
                            </div>
                          );
                        })}
                      </div>
                    );
                  })}
                </div>
              );
            })}

            {isRouteGeometryView
              ? taskTrip.units.map((unit) => {
                  const isView = viewUnits.some((x) => {
                    return x.id === unit.id && x.isView;
                  });

                  if (!isView || unit.geoJsonTrip.tripGeometries === null) return null;

                  return (
                    <div key={unit.id}>
                      {unit.geoJsonTrip.tripGeometries.routes.map((routeGeometry, index) => {
                        return <GeoJSON key={unit.id + index} data={routeGeometry.geometry} color={"black"} weight={1} />;
                      })}
                    </div>
                  );
                })
              : null}

            {taskTrip.units.map((unit) => {
              const isView = viewUnits.some((x) => {
                return x.id === unit.id && x.isView;
              });

              if (!isView || unit.mapPositions.routes.length === 0) return null;

              const startPoint = unit.mapPositions.routes[0].positions[0];

              const lastRouteIndex = unit.mapPositions.routes.length - 1;
              const finishPoint =
                unit.mapPositions.routes[lastRouteIndex].positions[unit.mapPositions.routes[lastRouteIndex].positions.length - 1];

              return (
                <div key={unit.id}>
                  <div>
                    <MapMarkerTaskTrip point={startPoint} title={"Начало"} unit={unit} />
                    <MapMarkerTaskTrip point={finishPoint} title={"Конец"} unit={unit} />
                  </div>

                  {unit.mapPositions.routes.map((route, index) => {
                    return (
                      <div key={index}>
                        <AntPath
                          positions={route.positions.map((item) => {
                            return [item.location.lat, item.location.long];
                          })}
                          options={{
                            delay: 1000,
                            dashArray: [30, 200],
                            weight: 3,
                            color: "#3388ff",
                            opacity: 1,
                            pulseColor: "#FFFFFF",
                            hardwareAccelerated: true,
                          }}
                          eventHandlers={{
                            click: (e) => {
                              console.log(e);
                            },
                          }}
                        >
                          {/*          <Popup className="mapPopup" /> */}
                        </AntPath>
                      </div>
                    );
                  })}
                </div>
              );
            })}

            {this.props.children}
          </MapContainer>

          <div>
            <TopRightMapControl top={"40px"}>
              <div className={styles.overlayer_control_container}>
                {isOverlayerControlOpen ? (
                  <div className={styles.overlayerOpenContainer}>
                    <TooltipWrapper title={"Закрыть панель объектов"} position="left">
                      <div className={styles.layersIconControlClose} onClick={() => this.setState({ isOverlayerControlOpen: false })}>
                        <HighlightOffIcon fontSize="small" />
                      </div>
                    </TooltipWrapper>

                    <TooltipWrapper title={`${isControlPointsView ? "Скрыть" : "Показать"} контрольные точки`} position="left">
                      <div
                        className={isControlPointsView ? styles.checkbox_layer : styles.checkbox_layer_disable}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({ isControlPointsView: !isControlPointsView });
                        }}
                      >
                        <span className={styles.statuses_container}>Контрольные точки</span>
                      </div>
                    </TooltipWrapper>

                    <TooltipWrapper title={`${isRouteGeometryView ? "Скрыть" : "Показать"} расчитанный маршрут рейса`} position="left">
                      <div
                        className={isRouteGeometryView ? styles.checkbox_layer : styles.checkbox_layer_disable}
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({ isRouteGeometryView: !isRouteGeometryView });
                        }}
                      >
                        <span className={styles.statuses_container}> Расчитанный маршрут рейса</span>
                      </div>
                    </TooltipWrapper>

                    {viewUnits.map((unit) => {
                      return (
                        <TooltipWrapper key={unit.id} title={`${unit.isView ? "Скрыть" : "Показать"} ${unit.title}`} position="left">
                          <div
                            className={unit.isView ? styles.checkbox_layer : styles.checkbox_layer_disable}
                            onClick={(e) => {
                              e.stopPropagation();
                              this.onChangeUnitView(unit.id, !unit.isView);
                            }}
                          >
                            <span className={styles.statuses_container}>
                              {" "}
                              {unit.title} {unit.registerNumber}
                            </span>
                          </div>
                        </TooltipWrapper>
                      );
                    })}
                  </div>
                ) : (
                  <TooltipWrapper title={"Открыть панель объектов"} position="left">
                    <div className={styles.layersIconControl} onClick={() => this.setState({ isOverlayerControlOpen: true })}>
                      <LayersIcon />
                    </div>
                  </TooltipWrapper>
                )}
              </div>

              <BaseLayerMapControl />
            </TopRightMapControl>
          </div>
        </div>
      </div>
    );
  }
}

export default withAppState(withMapControl(React.memo(LogisticReportsTaskTripMap)));
